import { IProps, IState } from '@/entity'

export interface MovieProps extends IProps {
  /** dva传过来的信息 */
  movieSession: any
  /** 当前时间 */
  serverTime?: string
}
const movieState: MovieProps = {
  title: 'test'
}
export default movieState;
